<template>
	<div class="CustomerContractBox">
		<div v-if="Dev">开发中......</div>
		<div v-else class="CustomerContract">
			<div class="TopBottomCom FormSelect">
				<FromComm :FromArr="FromArr"></FromComm>
				<div class="CommonBtngroup">
					<CommonBtngroup ref="Btngroup" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
			</div>
			<div class="TopBottomCom TableOrBtn">
				<!--   -->
				<div style="display: inline-block;" v-if="qx.openaccount">
					<Commonbtn backgroundColor="#FFF" title="备案开户" :optional="!optionalOpenAccount" opwidth="106px"
						:widthIcon="20" :heightIcon="20" fontSize="14px" @btnclick="OpenAccount"
						:src="require('@/assets/channel/DailyWork/OpenAccount.png')">
					</Commonbtn>
				</div>
				<div style="display: inline-block;" v-if="qx.openaccount">
					<Commonbtn backgroundColor="#FFF" title="确认合同" :optional="!agreementOpenAccount" opwidth="106px"
						:widthIcon="20" :heightIcon="20" fontSize="14px" @btnclick="agreement"
						:src="require('@/assets/icon/qy.png')">
					</Commonbtn>
				</div>
				<div style="display: inline-block;" v-if="qx.openaccount">
					<Commonbtn backgroundColor="#FFF" title="合同驳回" fontSize="14px" @btnclick="Reject"
						:src="require('@/assets/channel/Rejectapproval.png')">
					</Commonbtn>
				</div>
				<div style="display: inline-block;">
					<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="fileExport"
						:src="require('@/assets/icon/daoc.png')">
					</Commonbtn>
				</div>


				<div class="Table">
					<Commontable ref="refTableContract" @CZClick="CZClick" :FromUploadSetting="FromUploadSetting"
						:loadingTable="loadingTableContract" @onRowClick="onRowClick" width="918px" colnum=7
						:tableData="tableData" :headerData="headerData" height="100%">
					</Commontable>
					<div class="pagination">
						<Pagination ref="invPagination" type='allColor' @handleCurrentChange="handleCurrentChange"
							@handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
					</div>
				</div>
			</div>
		</div>
		<DialogFrom :width="DialogFromWidth" :title="TitleDialog" :rigthText="rigthText"
			:dialogVisible="dialogVisibDialogAll" @cancel="cancelDialogAll" @dialogOK="dialogOKDialogAll">
			<div style="margin-left: -10px;">
				<CommonbtnUpLoad v-show="TitleDialog == '经销商签约提交'" types='UploadAll'
					style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="上传" fontSize="14px"
					@getFile="UpLoadProcurementIndicators" :src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
				<div v-show="TitleDialog == '备案开户'">
					<FromComm :FromArr="FromArrOpenAccount"></FromComm>
				</div>
				<div v-show="TitleDialog == '合同驳回原因'">
					<el-input type="textarea" placeholder="请输入驳回原因" v-model="RejectReason">
					</el-input>
				</div>
			</div>
			<FilesAndPictures :DelFlag="false" v-for="(item , index) of lstAttachment" :key="index"
				:fileAddImgData="item" @See="See"></FilesAndPictures>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<!--  -->
		<Dialog width="420px" :title="Dialog.Title" :dialogVisible="Dialog.dialogVisibleDialog" @cancel="cancelDialog"
			@dialogOK="dialogOKDialog" :src="Dialog.src">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">{{ Dialog.Context }}</span>
		</Dialog>
		<Picturepreview :imgsrc="imgsrc" :show="imgShow" @hidefn="imgHide"></Picturepreview>
	</div>
</template>

<script>
	import FromComm from '../../components/fromComponents/Commfrom/from-comm.vue'
	import FromArrOpenAccount from './FromData/FromArrOpenAccount'
	import FromArr from './FromData/FromArr'
	import CommonBtngroup from '@/components/commongroup.vue'
	import Commontable from '@/components/common-table.vue'
	import Pagination from '@/components/pagination.vue'
	import headerData from './headerData/headerData'
	import Commonbtn from '@/components/common-btn.vue'
	import DialogFrom from '@/components/dialog-from.vue'
	import CommonbtnUpLoad from '@/components/common-upload.vue'
	import FilesAndPictures from '@/components/FilesAndPictures.vue'
	import Picturepreview from '@/components/picturepreview.vue'
	import Dialog from '@/components/dialog.vue'
	import utils from "../../../../../common/utils";
	import {
		HelperOpenAccountStatusByBuyFromHome,
		HelperContractStatus,
		CustomerContractCustomerList,
		CustomerContractUpLoadAttachment,
		CustomerContractAddContract,
		CustomerContractVerify,
		APPCustomerDoOpenAccount,
		CustomerContractReject,
		ContractCustomerExport
	} from '@/api/channel'
	import {
		InventoryClassList
	} from '@/api/home'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Commontable,
			DialogFrom,
			CommonbtnUpLoad,
			FilesAndPictures,
			Picturepreview,
			Pagination,
			Dialog
		},
		props: {},
		data() {
			return {
				Dev: false,
				loadingTableContract: true,
				dialogVisibDialogAll: false,
				dialogVisiblesdrjg: false,
				imgShow: false,
				imgsrc: '',
				RejectReason: '',
				TitleDialog: '加载中...',
				rigthText: '加载中...',
				DialogFromWidth: '500px',
				title: '',
				FromArr: [],
				headerData: [],
				tableData: [],
				lstAttachment: [],
				FromArrOpenAccount: [],
				tableDatadrjg: [],
				rowDatas: [],
				rowData: null,
				Dialog: {
					Title: '提示信息',
					dialogVisibleDialog: false,
					src: require('@/assets/icon/icon-del2.png'),
					Context: ''
				},
				FromUploadSetting: {
					accept: '*',
					multiple: false
				},
				PageIndex: 1,
				pageSize: 10,
				total: 0,
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changeth: false, //弃审
					approval: false, //驳回OR审批通过
					openaccount: false, //备案开户
					License: false
				},
			}
		},
		created() {},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.FromArrOpenAccount = JSON.parse(JSON.stringify(FromArrOpenAccount))
			this.HelperOpenAccountStatusByBuyFromHome()
			this.HelperContractStatus()
			this.inventoryClassList()
			this.CustomerContractCustomerList()
		},

		activated() {},
		updated() {},
		methods: {
			// 导出
			async fileExport() {
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ContractCustomerExport({
					CusName: this.FromArr[0].modelvalue,
					InvClass: this.FromArr[1].modelvalue,
					BuyFromHome: this.FromArr[4].modelvalue,
					OpenAccountStatus: this.FromArr[3].modelvalue,
					ContractStatus: this.FromArr[2].modelvalue,
					IsLicenseNormal: this.FromArr[5].modelvalue,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				});
				loading.close();
				if (resexprot) {
					utils.downloadFile(resexprot, "经销商签约", "xlsx");
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
			// 列表
			async CustomerContractCustomerList() {
				this.loadingTableContract = true
				let {
					code,
					message,
					data
				} = await CustomerContractCustomerList({
					CusName: this.FromArr[0].modelvalue,
					InvClass: this.FromArr[1].modelvalue,
					BuyFromHome: this.FromArr[4].modelvalue,
					OpenAccountStatus: this.FromArr[3].modelvalue,
					ContractStatus: this.FromArr[2].modelvalue,
					IsLicenseNormal: this.FromArr[5].modelvalue,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (code == 0) {
					this.total = data.Count
					data.data.forEach(item => {
						let czAll = [{
								title: '上传',
								clickName: 'NoUpload',
								BtnFalg: true
							},
							{
								title: '下载',
								clickName: 'download',
								BtnFalg: true
							},
						]
						if (item.BuyFromHome == 1 && this.qx.openaccount) {
							item['czAll'] = czAll
						}
					});
					this.tableData = data.data
				}
				this.loadingTableContract = false
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({});
				if (code == 0) {
					this.FromArr[1].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName,
						};
						this.FromArr[1].options.push(obj);
					});
				}
			},

			//合同状态接口
			async HelperContractStatus() {
				let {
					data,
					message,
					code
				} = await HelperContractStatus({})
				if (code == 0) {
					this.FromArr[2].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[2].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},
			//开户状态接口
			async HelperOpenAccountStatusByBuyFromHome() {
				let {
					data,
					message,
					code
				} = await HelperOpenAccountStatusByBuyFromHome({

				})
				if (code == 0) {
					this.FromArr[3].options = []
					this.FromArrOpenAccount[0].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[3].options.push(obj)
						this.FromArrOpenAccount[0].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},
			// 上传文件
			async CustomerContractUpLoadAttachment(file) {
				const loading = this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formData = new FormData()
				formData.append("file", file)
				let res = await CustomerContractUpLoadAttachment(formData)
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: res.message
					})
					this.lstAttachment = []
					this.lstAttachment.push(res.data)
				} else if (res.code == 101) {
					this.$message({
						type: 'warning',
						message: res.message
					})
				} else {
					this.$message({
						type: 'error',
						message: res.message
					})
				}
				loading.close();
			},
			// 提交
			async CustomerContractAddContract() {
				let {
					code,
					data,
					message
				} = await CustomerContractAddContract({
					CusCode: this.rowData.CusCode,
					InvClass: this.rowData.InvClass,
					FileName: this.lstAttachment[0].FileName
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibDialogAll = false
					this.CustomerContractCustomerList()
				} else {
					this.$message.warning(message)
				}
			},
			// 备案开户
			async APPCustomerDoOpenAccount() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					code,
					message,
					data
				} = await APPCustomerDoOpenAccount({
					InvClass: this.rowData.InvClass,
					CusCode: this.rowData.CusCode,
					OpenAccountStatus: this.FromArrOpenAccount[0].modelvalue
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibDialogAll = false
					this.CustomerContractCustomerList()
				} else if (code == 1) {
					this.$message.warning(message)
					this.dialogVisibDialogAll = false
					this.title = '备案开户结果'
					this.tableDatadrjg = data
					this.dialogVisiblesdrjg = true
					this.CustomerContractCustomerList()
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			OpenAccount() {
				if (this.rowData) {
					this.TitleDialog = '备案开户'
					this.rigthText = '确定'
					this.dialogVisibDialogAll = true
					this.DialogFromWidth = '1000px'
				} else {
					this.$message.warning("请选择您要操作的数据！")
				}

			},
			// 确认合同
			async CustomerContractVerify() {
				const loading = this.$loading({
					lock: true,
					text: '合同确认中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					message,
					code
				} = await CustomerContractVerify({
					CusCode: this.rowData.CusCode,
					InvClass: this.rowData.InvClass
				})
				if (code == 0) {
					this.$message.success(message)
					this.Dialog.dialogVisibleDialog = false
					this.CustomerContractCustomerList()
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			agreement() {
				if (this.rowData) {
					this.Dialog.dialogVisibleDialog = true
					this.Dialog.src = require('@/assets/icon/icon-errors.png')
					this.Dialog.Context = '您确定要确认这份合同吗？'
				} else {
					this.$message.warning("请选择您要操作的数据！")
				}
			},

			// 合同驳回
			async CustomerContractReject() {
				let {
					code,
					data,
					message
				} = await CustomerContractReject({
					CusCode: this.rowData.CusCode,
					InvClass: this.rowData.InvClass,
					RejectReason: this.RejectReason
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibDialogAll = false
					this.CustomerContractCustomerList()
				} else {
					this.$message.warning(message)
				}
			},
			Reject() {
				if (this.rowData) {
					this.TitleDialog = '合同驳回原因'
					this.rigthText = '确定'
					this.dialogVisibDialogAll = true
					this.DialogFromWidth = '975px'
				} else {
					this.$message.warning("请选择您要操作的数据！")
				}
			},
			select() {
				this.PageIndex = 1
				this.CustomerContractCustomerList()
			},
			reset() {
				this.FromArr.forEach((item, index) => {
					item.modelvalue = '';
				});
			},
			See(par) {
				console.log(par);
				if (par.Extension == 'jpg' || par.Extension == 'png' || par.Extension == 'gif') {
					this.imgShow = true
					this.imgsrc = par.FileUrl
				} else if (par.Extension == 'pdf') {
					window.open(par.FileUrl, '_blank')
				} else {
					window.location.href = par.FileUrl
				}
			},
			imgHide() {
				this.imgShow = false
			},
			cancelDialogAll() {
				this.dialogVisibDialogAll = false
			},
			dialogOKDialogAll() {
				if (this.TitleDialog == '经销商签约提交') {
					this.CustomerContractAddContract()
				} else if (this.TitleDialog == '备案开户') {
					this.APPCustomerDoOpenAccount()
				} else if (this.TitleDialog == '合同驳回原因') {
					this.CustomerContractReject()
				}
			},
			CZClick(obj) {
				this.rowData = obj.row
				if (obj.item.title == '下载') {
					if (obj.row.ContractFileUrl) {
						window.open(obj.row.ContractFileUrl, '_blank')
						// window.location.href = obj.row.ContractFileUrl
					} else {
						this.$message.warning("请先上传需要下载的文件！")
					}
				} else if (obj.item.title == '上传') {
					this.dialogVisibDialogAll = true
					this.TitleDialog = '经销商签约提交'
					this.rigthText = '提交'
					this.DialogFromWidth = '500px'
				}
			},
			onRowClick(val) {
				console.log(val.CusType);
				this.rowData = val
			},
			// handleSelectionChange(val) {
			//   this.rowDatas = val
			// },
			UpLoadProcurementIndicators(file) {
				this.CustomerContractUpLoadAttachment(file)
			},
			handleCurrentChange(PageIndex) {
				this.PageIndex = PageIndex
				this.CustomerContractCustomerList()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.CustomerContractCustomerList()
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			cancelDialog() {
				this.Dialog.dialogVisibleDialog = false
			},
			dialogOKDialog() {
				if (this.Dialog.Context == '您确定要确认这份合同吗？') {
					this.CustomerContractVerify()
				}
			},

		},
		computed: {
			optionalOpenAccount() {
				if (this.rowData) {
					return this.rowData.CusType == 0 && this.qx.openaccount
				} else {
					return false
				}
			},
			agreementOpenAccount() {
				if (this.rowData) {
					return this.rowData.CusType == 1 && this.qx.openaccount
				} else {
					return false
				}
			},
		},
		watch: {
			dialogVisibDialogAll: {
				handler(newDialogAll, oldDialogAll) {
					if (newDialogAll) {
						if (this.TitleDialog == '经销商签约提交') {
							this.lstAttachment = []
						} else if (this.TitleDialog == '备案开户') {
							this.FromArrOpenAccount[0].modelvalue = ''
						} else if (this.TitleDialog == '合同驳回原因') {
							this.RejectReason = ''
						}
					}
				},
				deep: true,
				immediate: true
			},
			$route: {
				handler(to, from) {
					let data = JSON.parse(localStorage.getItem("MenusData"))
					data.CusWebMenus.forEach((item, index) => {
						if (item.NodeID == 77) {
							item.Nodes.forEach((items, indexs) => {
								if (items.NodeID == to.query.NodeID) {
									items.Nodes.forEach((itemes, index) => {
										if (itemes.NodeID == to.query.MenuID) {
											this.qus = itemes.Buttons
										}
									})
								}
							})
						}
					});
					console.log(this.qus, 'qus');
					if (this.qus) {
						this.qus.map((item, index) => {
							if (item.NodeName == 'add') {
								this.qx.add = true
							} else if (item.NodeName == 'edit') {
								this.qx.update = true
							} else if (item.NodeName == 'delete') {
								this.qx.del = true
							} else if (item.NodeName == 'stopif') {
								this.qx.del = true
							} else if (item.NodeName == 'assignment') {
								this.qx.assignment = true
							} else if (item.NodeName == 'enabled') {
								this.qx.enabled = true
							} else if (item.NodeName == 'skip') {
								this.qx.skip = true
							} else if (item.NodeName == 'reset') {
								this.qx.reset = true
							} else if (item.NodeName == 'setting') {
								this.qx.setting = true
							} else if (item.NodeName == 'submit') {
								this.downlist.forEach((item, index) => {
									if (index == 0 || index == 1) {
										item.flag = true
									}
								})
								this.qx.submit = true
							} else if (item.NodeName == 'approval') {
								this.downlist.forEach((item, index) => {
									if (index == 2 || index == 3) {
										item.flag = true
									}
								})
								this.qx.approval = true
							} else if (item.NodeName == 'openaccount') {
								this.qx.openaccount = true
							} else if (item.NodeName == 'License') {
								this.qx.License = true
							}
						})
					}
				},
				deep: true,
				immediate: true
			},
		},
	}
</script>
<style scoped lang='less'>
	.CustomerContractBox {
		width: 100%;
		height: 100%;

		.CustomerContract {
			display: grid;
			gap: 32px;

			.TopBottomCom {
				margin: 1px 10px;
				width: 938px;
				box-shadow: 0px 1px 4px 2px #e5e7ea;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;

				.CommonBtngroup {
					margin-right: 23px;
					margin-top: 30px;
				}
			}

			.FormSelect {
				//   height: 198px;
				padding-bottom: 20px;
			}

			.TableOrBtn {
				// height: 198px;

				.Table {
					margin-top: 10px;
				}
			}
		}
	}
</style>